<dx-data-grid #dxDataGrid
  [dataSource]="timelogs"
  [showBorders]="true"
  [rowAlternationEnabled]="true"
  [columnAutoWidth]="true"
  
>
<dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-paging [pageSize]="100"></dxo-paging>
<dxi-column dataField="DateDDMMYYYY" [caption]="languageService.LNG('Label.Date')">
</dxi-column>
<!-- Tidspunkt -->
<dxi-column dataField="DateHHMM" [caption]="languageService.LNG('Label.Time')">
</dxi-column>
<!-- Endret av -->
<dxi-column dataField="ByEmployeeName" [caption]="languageService.LNG('Label.UpdatedBy')">
    
</dxi-column>
<!-- Fra status -->
<dxi-column dataField="OldStatusId" [caption]="languageService.LNG('Label.From.Status')" cellTemplate="fromStatusTemplate2">
    <dxo-lookup [dataSource]="statuses" valueExpr="StatusId" displayExpr="Description"></dxo-lookup>
</dxi-column>
<!-- Til status -->
<dxi-column dataField="StatusId" [caption]="languageService.LNG('Label.To.Status')" cellTemplate="toStatusTemplate2">
    <dxo-lookup [dataSource]="statuses" valueExpr="StatusId" displayExpr="Description"></dxo-lookup>
</dxi-column>

<!-- Timetype -->
<dxi-column dataField="TimeTypeCode" [caption]="languageService.LNG('Label.TimeType')">

</dxi-column>
<div *dxTemplate="let data of 'fromStatusTemplate2'">
  <div [style]="getStatusStyleValue(data.value)">{{getStatusText(data.value)}}</div>
</div>
<div *dxTemplate="let data of 'toStatusTemplate2'">
  <div [style]="getStatusStyleValue(data.value)">{{getStatusText(data.value)}}</div>
</div>
</dx-data-grid>
